// Éléments « inclus / non inclus » d'une activité.
// Ce sont des textes FIXES : on stocke une clé stable et on affiche le libellé
// traduit (fr/en/jp) via i18n — aucun service de traduction nécessaire.
// Le guide peut aussi ajouter du texte libre : il s'affiche alors tel quel.

export var INCLUDED_KEYS = ['guide', 'transport', 'entries', 'tasting', 'photos', 'drinks'];
export var NOT_INCLUDED_KEYS = ['meals', 'drinks', 'airport', 'tips', 'insurance', 'shopping'];

// Anciennes valeurs (stockées en clair en français avant l'i18n) -> clé stable.
// Permet aux activités déjà en ligne de s'afficher traduites sans migration.
var LEGACY = {
  'Guide privé': 'guide',
  'Transport local': 'transport',
  'Entrées des sites': 'entries',
  'Dégustation': 'tasting',
  'Photos souvenir': 'photos',
  'Boissons': 'drinks',
  'Repas': 'meals',
  'Transport aéroport': 'airport',
  'Pourboires': 'tips',
  'Assurance voyage': 'insurance',
  'Achats personnels': 'shopping'
};

var KNOWN = {};
INCLUDED_KEYS.concat(NOT_INCLUDED_KEYS).forEach(function (k) { KNOWN[k] = true; });

// Valeur stockée (clé, ancien texte FR, ou texte libre) -> clé canonique.
export function toKey(value) {
  if (!value) return value;
  if (KNOWN[value]) return value;
  return LEGACY[value] || value;
}

// Libellé traduit d'un élément pour la langue courante.
// Texte libre inconnu -> renvoyé tel quel (defaultValue).
export function itemLabel(t, value) {
  var key = toKey(value);
  return t('activityItems.' + key, { defaultValue: value });
}

// Normalise une liste stockée en clés canoniques (migration douce à l'édition).
export function normalizeItems(list) {
  return (list || []).map(toKey);
}
